import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import WaterDropOutlinedIcon from '@mui/icons-material/WaterDropOutlined';
import ThunderstormOutlinedIcon from '@mui/icons-material/ThunderstormOutlined';
import BlurOnOutlinedIcon from '@mui/icons-material/BlurOnOutlined';
import AcUnitOutlinedIcon from '@mui/icons-material/AcUnitOutlined';

import { ICondicaoTempo } from '../../shared/services/api/mercado';

// Ícone da condição do tempo — usado no painel do cabeçalho (PrevisaoTempo)
// e no dialog da previsão detalhada (DialogPrevisaoTempo), cada um com a
// paleta de cores do seu fundo.
export const IconeCondicao: React.FC<{
  icone: ICondicaoTempo['icone'];
  tamanho: number;
  cores: Record<ICondicaoTempo['icone'], string>;
}> = ({ icone, tamanho, cores }) => {
  const sx = { fontSize: tamanho, color: cores[icone] };
  switch (icone) {
  case 'sol': return <WbSunnyOutlinedIcon sx={sx} />;
  case 'nublado': return <CloudOutlinedIcon sx={sx} />;
  case 'chuva': return <WaterDropOutlinedIcon sx={sx} />;
  case 'tempestade': return <ThunderstormOutlinedIcon sx={sx} />;
  case 'neblina': return <BlurOnOutlinedIcon sx={sx} />;
  default: return <AcUnitOutlinedIcon sx={sx} />;
  }
};
